// extracted by mini-css-extract-plugin
export default {"icon":"src-components-Modules-revamp-ImageAndPoster-Text-css-module__icon--rZPDE"};